<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

const authStore = useAuthStore()

onMounted(async () => {
  await authStore.initialize()
})
</script>

<template>
  <div class="min-h-screen">
    <!-- Loading state -->
    <div
      v-if="authStore.isLoading && !authStore.initialized"
      class="flex min-h-screen items-center justify-center"
    >
      <LoadingSpinner size="lg" message="Initializing..." />
    </div>

    <!-- Main app -->
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
